import { Outlet } from 'react-router-dom';
import { isAfterByUnix, isBeforeByUnix } from './utils/common';
import { ENVS } from './constants';
import dayjs from 'dayjs';
import { NotOpenPanel, ProjectEndPanel } from './components/AirdropPanel';

function App() {
  const isBeforeClaim = isBeforeByUnix(dayjs(ENVS.startTime).unix());

  const isEndClaim = isAfterByUnix(dayjs(ENVS.endTime).unix());

  if (ENVS.ENV === 'dev') {
    return <Outlet />;
  }

  if (isBeforeClaim) {
    return <NotOpenPanel />;
  }

  if (isEndClaim) {
    return <ProjectEndPanel />;
  }

  return <Outlet />;
}

export default App;
